export enum Bookmaker {}

export const BookmakerCode: Record<number, string> = {};

export const BookmakerName: Record<number, string> = {};

export const BookmakerRulesLink: Record<number, string> = {};

export const BookmakerTermsLink: Record<number, string> = {};

export const SbobetAllowedCustomLeagueIds: number[] = [];
export const IbcbetAllowedLimitsCategoryIds: number[] = [];
